import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "../../styles/EditProfile.css"; // Import your CSS file for styling
import Navbar from "../../layouts/Navbar";
import loginImg from "../../assets/loginImage.jpeg";
import api from "../../api/config";
import { ToastContainer, toast } from "react-toastify";
import Skeleton from "react-loading-skeleton";
import { EMAIL_REGEX } from "../../constants/common";
import axios from "axios";

const EditProfile = () => {
  const [userProfile, setUserProfile] = useState({});
  const [profileImage, setProfileImage] = useState(null);
  const [isValid, setIsValid] = useState(true);
  const [loading, setLoading] = useState(false);
  const [currentMobile, setCurrentMobile] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    const getUserProfile = async () => {
      setLoading(true);
      try {
        const response = await api.get("/user-profile");
        if (response?.data?.status === 200) {
          setUserProfile(response?.data?.response);
          setCurrentMobile(response?.data?.response?.mobile);
        }
      } catch (error) {
        //console.logerror);
        toast.error("Something went wrong");
      } finally {
        setLoading(false);
      }
    };

    getUserProfile();
  }, []);

  const handleAvatarChange = (event) => {
    setProfileImage(event.target.files[0]);
  };

  const editProfile = async (event) => {
    event.preventDefault();

    // Trim spaces from first name and last name
    const trimmedFirstName = userProfile.firstName.trim();
    const trimmedLastName = userProfile.lastName.trim();

    // Check if any required fields are empty
    if (
      !trimmedFirstName ||
      !trimmedLastName ||
      !userProfile.email ||
      !userProfile.mobile
    ) {
      toast.error("Please fill in all required fields");
      return;
    }

    const mobileRegex = /^[0-9]{8,15}$/;
    if (!mobileRegex.test(userProfile.mobile)) {
      toast.error("Invalid mobile number");
      return;
    }

    const nameRegex = /^[A-Za-z]+$/;
    if (!nameRegex.test(trimmedFirstName) || !nameRegex.test(trimmedLastName)) {
      toast.error("First Name and Last Name should only contain alphabets");
      return;
    }
    const isMobileExistResponse = await api.get(
      `/is-exist/user/${userProfile.mobile}`
    );
    if (
      isMobileExistResponse.data.status === 200 &&
      currentMobile !== userProfile.mobile
    ) {
      toast.error("Mobile Number Already Exists.");
      return;
    }
    const data = {
      firstName: trimmedFirstName,
      lastName: trimmedLastName,
      email: userProfile.email,
      mobile: userProfile.mobile,
    };

    try {
      const formData = new FormData();
      if (profileImage) {
        formData.append("file", profileImage);
      }
      formData.append("data", JSON.stringify(data));

      const response = await api.post("/update-user-profile", formData);

      if (response?.data?.status === 200) {
        toast.success("Profile updated successfully");
        navigate("/user-profile");
      } else {
        toast.error("Failed to update profile");
      }
      const IsMobileExist = await axios.get(
        `https://yelospace.com/api/is-exist/user/${formData.mobile}`
      );

      if (IsMobileExist.data.status === 200) {
        toast.error("Moblie Number Already Exists.");
        return;
      }
    } catch (error) {
      //console.logerror);
      toast.error("Something went wrong");
    }
  };

  const handleChangeEmail = (e) => {
    setIsValid(EMAIL_REGEX.test(e.target.value));
    const { name, value } = e.target;
    setUserProfile((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleChange = (event) => {
    const { name, value } = event.target;
    setUserProfile((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  return (
    <>
      <Navbar />
      <ToastContainer />
      <div className="edit-profile-container">
        <div className="edit-profile-left">
          <img src={loginImg} alt="Left Panel Image" />
        </div>
        <div className="edit-profile-right">
          <h3>Edit My Profile</h3>
          <div className="profile-avatar">
            <input
              type="file"
              accept="image/*"
              id="avatar-upload"
              onChange={handleAvatarChange}
              style={{ display: "none" }}
            />
            <label htmlFor="avatar-upload">
              {loading ? (
                <Skeleton circle height={150} width={150} />
              ) : (
                <img
                  src={
                    !!userProfile?.profileImage
                      ? userProfile?.profileImage
                      : profileImage
                      ? URL.createObjectURL(profileImage)
                      : "https://via.placeholder.com/150"
                  }
                  alt="Avatar"
                  className="avatar-image"
                />
              )}
            </label>
          </div>

          <div className="form-box-custum">
            <form onSubmit={editProfile}>
              <div className="form-group-custum">
                {loading ? (
                  <Skeleton height={46} width={177} />
                ) : (
                  <input
                    onChange={handleChange}
                    name="firstName"
                    type="text"
                    placeholder="First Name *"
                    value={userProfile.firstName}
                  />
                )}
              </div>
              <div className="form-group-custum">
                {loading ? (
                  <Skeleton height={46} width={177} />
                ) : (
                  <input
                    onChange={handleChange}
                    name="lastName"
                    type="text"
                    placeholder="Last Name *"
                    value={userProfile.lastName}
                  />
                )}
              </div>
              <div className="form-group-custum">
                {loading ? (
                  <Skeleton height={46} width={177} />
                ) : (
                  <input
                    onChange={handleChangeEmail}
                    name="email"
                    type="email"
                    placeholder="Email *"
                    disabled
                    value={userProfile.email}
                  />
                )}
                {!isValid && (
                  <span className="custom-error">
                    Please enter a valid email address
                  </span>
                )}
              </div>
              <div className="form-group-custum">
                {loading ? (
                  <Skeleton height={46} width={177} />
                ) : (
                  <input
                    onChange={handleChange}
                    name="mobile"
                    type="tel"
                    placeholder="Mobile *"
                    value={userProfile.mobile}
                  />
                )}
              </div>

              <button
                disabled={loading ? true : false}
                className="btn fw-bold "
                type="submit"
              >
                Update
              </button>
              
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default EditProfile;
